/* Built In Imports */
import { useEffect, useState } from 'react';

/* External Imports */
import { Box } from '@chakra-ui/react';
import YouTube from 'react-youtube';
// import ReactPlayer from 'react-player';

/* Internal Imports */
import { getEmbedUrl } from '@components/Utility/utils';
/* Components */
import MidContainer from '@Layout/MidContainer';

/* Services */
/* Styles */
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

/**
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data for Section
 * @param sectionContent.margin
 * @param sectionContent.width
 * @param sectionContent.pxBase
 * @returns {ReactElement} MediaEmbed component
 */

const MediaEmbedV2 = ({ sectionContent, margin, width }) => {
  const [vidVis, setVidVis] = useState(true);
  const [opts, setOpts] = useState({});
  // const { isOpen, onOpen, onClose } = useDisclosure();

  useEffect(() => {
    setOpts({
      height: document.getElementById('msr-vid')?.clientHeight,
      // height: '315',
      width: '100%',
      playerVars: {
        autoplay: 0,
      },
    });
  }, [global?.window]);

  const onReady = event => {
    event.target.pauseVideo();
  };

  return (
    <MidContainer w={width || '696px'}>
      <Box
        // backgroundImage={sectionContent?.video?.thumbnailUrl}
        backgroundSize="cover"
        backgroundColor="#000"
        backgroundRepeat="no-repeat"
        backgroundPosition="center"
        width="100%"
        position="relative"
        display="flex"
        justifyContent="center"
        alignItems="center"
        flexDir="column"
        cursor="pointer"
        onClick={() => setVidVis(!vidVis)}
        overflow="hidden"
        height={{ base: '300px', md: '430px' }}
        m={margin || '0 auto 30px auto'}
        id="msr-vid"
      >
        {' '}
        {vidVis && (
          <Box maxW="100%" w="full">
            <YouTube
              videoId={getEmbedUrl(sectionContent?.video?.url)}
              onReady={onReady}
              opts={opts}
              loading="lazy"
            />{' '}
          </Box>
        )}
      </Box>
    </MidContainer>
  );
};

export default MediaEmbedV2;
